<template>
    <div class="container block-social-icons margin-both-lg">
        <h2 class="titler margin-bottom-lg">Følg oss!</h2>
        <SocialLinks caption/>
    </div>
</template>

<script>
import SocialLinks from '@/components/elements/SocialLinks';

export default {
    name: 'social-icons',
    props: ['data'],
    computed:{
        
    },
    components:{
        SocialLinks
    },
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.block-social-icons{
    text-align: center;
    .titler{
    }
    svg{
        path{
            fill: $darkL
        }
    }
    .links{
        max-width: 700px;
        margin-left: auto;
        margin-right: auto;
        justify-content: space-between;
        display: flex;
    }
    li{
        span{
            margin-top: 18px;
            font-weight: bold;
            @include fluid-type($smallResText, $wideResText, 10px, 20px);
            display: block;
            text-transform: capitalize;
            @include mquery($phone){
                margin-top: 5px;
                font-weight: 500;
            }
        }
    }
}
</style>